import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { GenderItem } from 'features/genders/types/genders.types'

type UseCreateGenderMutationProps = {
	onSuccess: () => void
}

export const useCreateGenderMutation = ({ onSuccess }: UseCreateGenderMutationProps) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createGender, isPending: createGenderLoading } = useMutation({
		mutationFn: (data: Pick<GenderItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.genders(''), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.genders.all })
			useToast({ type: 'success', message: t('New gender created!') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createGender,
		createGenderLoading
	}
}
